module.exports = __webpack_public_path__ + "img/insurance-life-buoy.cf72059.png";